import axios from "axios";
import { base_URL } from '../config/config';
const API_BASE_URL = `${base_URL}/api`;

export const getBlogs = async (page = 1, limit = 10) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.get(`${API_BASE_URL}/blogs/getBlogs`, {
      params: {
        limit, page
      },
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error fetching blogs', error);
  }
}

export const createBlog = async(body) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.post(`${API_BASE_URL}/blogs/addBlog`, body, { headers: { Authorization:`Bearer ${accessToken}` }});
    return response.data;
  }
  catch(error) {
    console.error('Error creating blog', error);
  }
}

export const updateBlog = async(id, body) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.post(`${API_BASE_URL}/blogs/editBlog/${id}`, body, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error updating blog', error);
  }
}

export const deleteBlog = async(id) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.post(`${API_BASE_URL}/blogs/deleteBlog/${id}`, {}, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error deleting blog', error);
  }
}

export const getBlog = async(id) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.get(`${API_BASE_URL}/blogs/getBlog/${id}`, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error deleting blog', error);
  }
}



export const changeStatus = async(id, body) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.post(`${API_BASE_URL}/blogs/changeStatus/${id}`,body, {
       headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });
    return response.data;
  }
  catch(error) {
    console.error('Error deleting blog', error);
  }
}